/**
 * Lightweight logger — silences non-error output in production builds.
 * Errors always surface for observability.
 */
const isDev = process.env.NODE_ENV !== "production";

export const log = {
  debug: (...args) => { if (isDev) console.debug(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  error: (...args) => { console.error(...args); },
};
